import React, { Component } from 'react';
import { Link, Navigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default class MerchantIntroduction extends Component {

    

    render() {

        // var userToken = localStorage.getItem('token');

        // if (!userToken) {
        //     return <Navigate to='/login' replace="true" />
        // }

        return (

            <div>

                <div class="docs-content">

                    <div class="container">


                        <article class="docs-article" id="section-1">

                            <h1 class="docs-heading">
                                Introduction
                            </h1>


                            <section class="docs-intro">

                                <p>
                                    The E-Pocket Merchant API enables partners and
                                    third-party applications to perform international
                                    remittance transactions through secure REST APIs.
                                </p>

                            </section>


                        </article>



                        <article class="docs-article">


                            <section class="docs-section">


                                <h2 class="section-heading">
                                    Environment URLs
                                </h2>


                                <table class="table table-bordered table-white">


                                    <thead>

                                        <tr>
                                            <th>
                                                Environment
                                            </th>

                                            <th>
                                                Base URL
                                            </th>
                                        </tr>

                                    </thead>


                                    <tbody>


                                        <tr>

                                            <td>
                                                Production
                                            </td>

                                            <td>
                                                https://merchant.e-pocket.com/
                                            </td>

                                        </tr>


                                        <tr>

                                            <td>
                                                Sandbox
                                            </td>

                                            <td>
                                                https://staging-merchant.e-pocket.com/
                                            </td>

                                        </tr>


                                    </tbody>


                                </table>


                            </section>


                        </article>




                        <article class="docs-article">


                            <section class="docs-section">


                                <h2 class="section-heading">
                                    Supported Features
                                </h2>


                                <table class="table table-bordered table-white">


                                    <thead>

                                        <tr>

                                            <th>
                                                Feature
                                            </th>

                                            <th>
                                                Description
                                            </th>

                                        </tr>

                                    </thead>


                                    <tbody>


                                        <tr>

                                            <td>
                                                Country Retrieval
                                            </td>

                                            <td>
                                                Retrieve supported remittance countries.
                                            </td>

                                        </tr>


                                        <tr>

                                            <td>
                                                Corridor Retrieval
                                            </td>

                                            <td>
                                                Retrieve available payout methods.
                                            </td>

                                        </tr>


                                        <tr>

                                            <td>
                                                Exchange Rate Calculation
                                            </td>

                                            <td>
                                                Calculate sender and receiver amounts.
                                            </td>

                                        </tr>


                                        <tr>

                                            <td>
                                                Payout Institution Retrieval
                                            </td>

                                            <td>
                                                Retrieve supported payout institutions.
                                            </td>

                                        </tr>


                                        <tr>

                                            <td>
                                                Recipient Form Retrieval
                                            </td>

                                            <td>
                                                Retrieve dynamic beneficiary fields.
                                            </td>

                                        </tr>


                                        <tr>

                                            <td>
                                                Branch Code Retrieval
                                            </td>

                                            <td>
                                                Retrieve bank branch codes.
                                            </td>

                                        </tr>


                                        <tr>

                                            <td>
                                                Payment Processing
                                            </td>

                                            <td>
                                                Submit remittance transactions.
                                            </td>

                                        </tr>


                                        <tr>

                                            <td>
                                                Transaction Tracking
                                            </td>

                                            <td>
                                                Retrieve transaction status and details.
                                            </td>

                                        </tr>


                                    </tbody>


                                </table>


                            </section>


                        </article>

                        <article class="docs-article" id="section-3">
                            <section class="docs-section row" id="item-3-1">
                                <div class="col-12">
                                    <nav aria-label="Page navigation example">
                                        <ul class="pagination justify-content-between">
                                        <li class="page-item">
                                        </li>

                                        <li class="page-item">
                                            <Link
                                                class="page-link"
                                                 to="/merchant-authentication"
                                            >
                                                Authentication&nbsp;
                                                <i class="bi bi-arrow-right"></i>
                                            </Link>
                                        </li>
                                        </ul>
                                    </nav>
                                </div>

                            </section>

                        </article>



                    </div>

                </div>


            </div>

        )

    }

}